import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { ResponseTerminalDto } from '../types/dtos';
import { constructQueryParams } from 'utils/query-params-builder';
import { APP_ENDPOINTS } from 'app/endpoints';

export type TerminalsQueryParams = BaseQueryParams;

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<PaginatedResponse<ResponseTerminalDto>, TerminalsQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const terminalsResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.TERMINALS, _arg));

            if (terminalsResponse.error) {
                return { error: terminalsResponse.error };
            }

            const terminals = terminalsResponse.data as PaginatedResponse<ResponseTerminalDto>;

            return {
                data: terminals,
            };
        },
        providesTags: [{ type: 'terminals', id: 'GET' }],
    });
